<template>
    <badge :type="getTypeBasedOnStatus()" :title="getTextBasedOnStatus()"/>
</template>

<script>
import Badge from "../../elements/Badge.vue";

export default {
    name: "LeadStatus",
    components: {Badge},
    props: {
        status: {
            type: [null, String],
            default: null
        },
        translations: {
            type: Object,
            default: () => ({})
        }
    },
    methods: {
        getTypeBasedOnStatus() {
            switch (this.status) {
                case 'converted':
                    return 'success'
                case 'rejected':
                    return 'error'
                case 'submitted':
                    return 'pending'
                default:
                    return 'neutral'
            }
        },
        getTextBasedOnStatus() {
            const t = this.translations;

            switch (this.status) {
                case null:
                    return 'n/a'
                case 'submitted':
                    return t.portal_translation_general_lead_status_submitted || 'Submitted'
                case 'converted':
                    return t.portal_translation_general_lead_status_converted || 'Converted'
                case 'rejected':
                    return t.portal_translation_general_lead_status_rejected || 'Rejected'
                default:
                    return this.status.charAt(0).toUpperCase() + this.status.slice(1);
            }
        }
    }
}
</script>
